export const wsPositionsFields = [
  {
    label: "Nombre",
    field: "ws_pos",
    sort: "asc",
    width: 50,
  },
  {
    label: "Estado",
    field: "status_name",
    sort: "asc",
    width: 50,
  },
  {
    label: "Control de bloqueo",
    field: "disponible",
    sort: "asc",
    width: 10,
  },
  {
    label: "Modo de trabajo",
    field: "checkForWork",
    sort: "asc",
    width: 50,
  },
  {
    label: "Punto externo",
    field: "confirmation_point",
    sort: "asc",
    width: 50,
  },
  {
    label: "Cola inicial",
    field: "queue_init",
    sort: "asc",
    width: 50,
  },
  {
    label: "Cola final",
    field: "queue_end",
    sort: "asc",
    width: 50,
  },
  {
    label: "Editar Colas",
    field: "editButton",
    sort: "asc",
    width: 50,
  },
  {
    label: "Punto de rotación",
    field: "rotatePoint",
    sort: "asc",
    width: 50,
  },
  {
    label: "Editar Rotación",
    field: "editRotateButton",
    sort: "asc",
    width: 50,
  },
  {
    label: "Valor caras",
    field: "faces_values",
    sort: "asc",
    width: 80
  },
  {
    label: "Editar Caras",
    field: "editFaceButton",
    sort: "asc",
    width: 50,
  }
];

export const wsPositionsFieldsUser = [
  {
    label: "Nombre",
    field: "ws_pos",
    sort: "asc",
    width: 50,
  },
  {
    label: "Estado",
    field: "status_name",
    sort: "asc",
    width: 50,
  },
  {
    label: "Control de bloqueo",
    field: "disponible",
    sort: "asc",
    width: 50,
  },
];

export function wsPositionsFieldsByRole(role) {
  switch (role) {
    case 1:
      return wsPositionsFields;
    case 2:
      return wsPositionsFields;
    default:
      return wsPositionsFieldsUser;
  }
}

export const position_status = {
  0: { name: "Bloqueada", color: "danger" },
  1: { name: "Proceso de bloqueo", color: "warning" },
  2: { name: "Disponible", color: "success" },
  3: { name: "Ocupada", color: "primary" },
  4: { name: "Reservada", color: "primary" },
};
